import { render } from "./B2bPageReportes.vue?vue&type=template&id=2ae411ee&scoped=true&lang=pug"
import script from "./B2bPageReportes.vue?vue&type=script&lang=js"
export * from "./B2bPageReportes.vue?vue&type=script&lang=js"

import "./B2bPageReportes.vue?vue&type=style&index=0&id=2ae411ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae411ee"]])

export default __exports__